class PrefixedStorageCache {
  constructor(keyPrefix, storage = sessionStorage) {
    this.keyPrefix = keyPrefix
    this.storage = storage
  }

  clear = (keepPlan = false) => {
    for (let i = 0; i < this.storage.length; i += 1) {
      const key = this.storage.key(i)
      if (
        key.startsWith(this.keyPrefix) &&
        (!keepPlan || key.indexOf('get_plans') < 0)
      ) {
        this.storage.removeItem(key)
      }
    }
  }

  delete = (key) => this.storage.removeItem(`${this.keyPrefix}${key}`)

  deleteAll = (deleteKey) => {
    for (let i = 0; i < this.storage.length; i += 1) {
      const key = this.storage.key(i)
      if (key.startsWith(this.keyPrefix) && key.indexOf(deleteKey) > 0) {
        this.storage.removeItem(key)
      }
    }
  }

  get = (key) => JSON.parse(this.storage.getItem(`${this.keyPrefix}${key}`))

  has = (key) => this.storage.getItem(`${this.keyPrefix}${key}`) !== null

  set = (key, value, retry = 1) => {
    try {
      this.storage.setItem(`${this.keyPrefix}${key}`, JSON.stringify(value))
    } catch (err) {
      this.clear(true)
      if (retry > 0) {
        this.set(key, value, retry - 1)
      }
    }
  }
}

export { PrefixedStorageCache }
